import { withTheme } from '../ThemeProvider';
import { StyledAccordion } from './styles';
import { AccordionProps } from './types';

const AccordionComponent: React.FC<AccordionProps> = ({
  items = [],
  activeKey,
  defaultActiveKey,
  accordion = false,
  bordered = true,
  ghost = false,
  collapsible,
  expandIcon,
  expandIconPosition = 'end',
  size = 'middle',
  destroyOnHidden = false,
  onChange,
  className,
  style,
  classNames,
  styles,
  ...rest
}: AccordionProps) => {
  // Transform expandIconPosition to match Ant Design's API
  const antExpandIconPosition = expandIconPosition === 'start' ? 'start' : 'end';

  // Map destroyOnHidden to destroyInactivePanel for Ant Design
  const destroyInactivePanel = destroyOnHidden;

  return (
    <div
      className={classNames?.wrapper}
      style={{
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        ...styles?.wrapper,
      }}
    >
      <StyledAccordion
        items={items}
        activeKey={activeKey}
        defaultActiveKey={defaultActiveKey}
        accordion={accordion}
        bordered={bordered}
        ghost={ghost}
        collapsible={collapsible}
        expandIcon={expandIcon}
        expandIconPosition={antExpandIconPosition}
        size={size}
        destroyInactivePanel={destroyInactivePanel}
        onChange={onChange}
        className={className}
        style={{
          width: '100%',
          ...style,
        }}
        {...rest}
      />
    </div>
  );
};

export const Accordion = withTheme(AccordionComponent);
